import React from 'react';

import { Grid, TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { Stack } from '@liscio/ui';

import { CreateAccountSectionProps } from './sectionTypes';
import { LabeledField, SubsectionTitle } from '../CreateAccountFormFieldPrimitives';
import { CreateAccountFormValues } from '../createAccountValidationSchema';

const TECH_FIELDS = [
  { name: 'co_tech_accounting' as const, label: 'Client Accounting' },
  { name: 'co_tech_expenses' as const, label: 'Expense Reimbursement' },
  { name: 'co_tech_time_trackings' as const, label: 'Time Tracking' },
  { name: 'co_tech_payroll' as const, label: 'Payroll' },
  { name: 'co_tech_billpay' as const, label: 'Bill pay' },
];

export const CreateAccountTechnologySolutionsFields: React.FC<
  CreateAccountSectionProps
> = ({ layout = 'responsive' }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<CreateAccountFormValues>();

  const fieldBreakpoint = layout === 'single-column' ? 12 : 4;

  return (
    <Stack spacing={2}>
      <SubsectionTitle>Technology Solutions</SubsectionTitle>
      <Grid container spacing={2.5} width="100%" sx={{ m: 0 }}>
        {TECH_FIELDS.map(({ name, label }) => (
          <Grid item xs={12} sm={fieldBreakpoint} key={name}>
            <LabeledField label={label}>
              <TextField
                {...register(name)}
                fullWidth
                error={Boolean(errors[name])}
                helperText={errors[name]?.message}
                autoComplete="off"
              />
            </LabeledField>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default CreateAccountTechnologySolutionsFields;
